import React from "react";
import { Box, Button, Toolbar } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CloudDownload from "@material-ui/icons/CloudDownload";
import PlayIcon from "@material-ui/icons/PlayCircleFilled";
import intl from "react-intl-universal";

interface EventListToolbarProps {
  numSelected: number;
  onPlayClick: () => void;
  onExportClick: () => void;
}

export const EventListToolbar = ({
  numSelected,
  onPlayClick,
  onExportClick,
}: EventListToolbarProps) => {
  return (
    <Toolbar>
      {numSelected > 0 && (
        <>
          <Typography color="inherit" variant="h3" component="div">
            {numSelected} {intl.get("TEAM_DASHBOARD_VIDEO_SELECT")}
          </Typography>
          <Box ml={4} />
        </>
      )}
      {numSelected > 0 && (
        <>
          <Button
            variant="contained"
            color="secondary"
            onClick={onPlayClick}
            startIcon={<PlayIcon />}
          >
            {intl.get("TEAM_DASHBOARD_PLAY_VIDEO")}
          </Button>
          <Box ml={4} />
          <Button
            disabled
            variant="contained"
            color="secondary"
            onClick={onExportClick}
            startIcon={<CloudDownload />}
          >
            {intl.get("TEAM_DASHBOARD_EXPORT_VIDEO")}
          </Button>
        </>
      )}
    </Toolbar>
  );
};
